export class Admin {
    userID: string = "";
    firstName: string = "";
    lastName: string = "";
    email: string = "";
    accessID: number = 0;
    accessLevelID: number = -1;
    accessLevel: string = "";
    status: boolean = true;
    accessName: string = "";

    constructor(email: string, firstName: string, lastName: string, userID: string,
        accessId: number, accessLevel: string, status: boolean, accessLevelID: number, accessName: string ) {
        this.email = email;
        this.firstName = firstName;
        this.lastName = lastName;
        this.accessID = accessId;
        this.accessLevel = accessLevel;
        this.status = status;
        this.accessLevelID = accessLevelID;
        this.accessName = accessName;
    }
}